import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, Select, MenuItem } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/index.scss';
import './scss/login.scss';
import Color from '@tool/color';
import LoginSlick from './component/login-slick';
import LoginComp from './component/login-comp';
import {
  DButton, SmallButton, LoginButton, EButton,
  DInput, DCheckbox, LButton, FButton,
} from './styled';
import moSetting, {
  changeIndustry, changeJob, changeCity, changeScale, changeNature, onSure,
  resetIndustryEmpty, reset,
} from './store/setting';
import moInfo, { getInfo } from '@store/info';
import moSkin from '@store/skin';
import { buildAuthPagePath } from '@lib/registration-attribution';
import SingleModal from '@comp/modal/single-industry';
import moSingle, {
  getIndustry, toggleModal,
} from '@comp/modal/store/single-industry';

interface IProps {}
interface IState {}

const DSelect = styled(Select)(() => ({
  height: '40px',
  width: '360px',
  border: 'none',

  '& .placeholder-111': {
    fontWeight: 500,
    color: Color.da,
  },
}));

const ESelect = styled(DSelect)(() => ({
  color: `${Color.blackColor(0.87)} !important`,
  cursor: 'pointer !important',

  '& .Mui-disabled': {
    color: `${Color.blackColor(0.87)} !important`,
    textFillColor: `${Color.blackColor(0.87)} !important`,
    cursor: 'pointer !important',

    '& .placeholder-111': {
      textFillColor: Color.da,
      color: Color.da,
    },
  },
  '& .MuiSelect-icon': {
    color: `${Color.blackColor(0.54)} !important`,
  },
}));

const EInput = styled(DInput)(() => ({
  marginTop: '20px',
}));

const DMenuItem = styled(MenuItem)(() => ({
  fontSize: '14px',
  color: Color.c55,
}));

const RegisterSetting = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const {
    industry, job, city, scale, nature,
    industryEmpty, roleEmpty,
  } = moSetting;
  const { mainColor } = moSkin;
  const { industryList, cityList, scaleList, natureList } = moInfo;
  const { name } = moSingle;

  useEffect(() => {
    getIndustry();
    getInfo(reset);
    document.title = '注册设置';
    return () => {};
  }, []);

  // 提交
  const onSubmit = () => {
    onSure(() => { navi(buildAuthPagePath('/login', window.location.search)); });
  };

  return (
    <section className="page-1101">
      <LoginSlick />
      <LoginComp>
        <section className="login-155">
          <section className="line-010">
            <strong>初始设置</strong>
          </section>
          <section className="line-012">
            <section className="line-115 line-116">
              <ESelect size="small" value={name} disabled={true}
                displayEmpty={true} onClick={() => {
                  resetIndustryEmpty();
                  toggleModal(true);
                }}
                renderValue={() => {
                  return !name ? <span className="placeholder-111">我所在的行业</span> : name;
                }}>
              </ESelect>
              <span className={[
                'err-11', industryEmpty ? 'err-visible' : 'err-hidden',
              ].join(' ')}>我所在的行业不能为空
              </span>
            </section>
            <section className="line-115 line-117">
              <DSelect size="small" value={job}
                onChange={changeJob} displayEmpty={true}
                renderValue={() => {
                  return !job ? <span className="placeholder-111">我的角色</span> : job;
                }}>
                <DMenuItem value='招聘'>招聘</DMenuItem>
                <DMenuItem value='薪酬福利'>薪酬福利</DMenuItem>
                <DMenuItem value='组织发展'>组织发展</DMenuItem>
                <DMenuItem value='人才发展'>人才发展</DMenuItem>
                <DMenuItem value='培训'>培训</DMenuItem>
                <DMenuItem value='HR综合'>HR综合</DMenuItem>
                <DMenuItem value='业务负责人'>业务负责人</DMenuItem>
                <DMenuItem value='个人'>个人</DMenuItem>
                <DMenuItem value='其他'>其他</DMenuItem>
              </DSelect>
              <span className={[
                'err-11', roleEmpty ? 'err-visible' : 'err-hidden',
              ].join(' ')}>我的角色不能为空
              </span>
            </section>
            <section className="line-015">
              <p className="line-0151"><i /><span>以下非必填项</span><i /></p>
            </section>
            <section className="line-115 line-116">
              <DSelect size="small" value={city}
                onChange={changeCity} displayEmpty={true}
                renderValue={() => {
                  return !city ? <span className="placeholder-111">我所在的城市</span> : city;
                }}>
                {cityList.map((city: any) => (
                  <DMenuItem key={city.code} value={city.name}>{city.name}</DMenuItem>
                ))}
              </DSelect>
            </section>
            <section className="line-115 line-116">
              <DSelect size="small" value={scale}
                onChange={changeScale} displayEmpty={true}
                renderValue={() => {
                  return !scale ? <span className="placeholder-111">企业规模</span> : scale;
                }}>
                {scaleList.map((item: any) => (
                  <DMenuItem key={item.code} value={item.name}>{item.name}</DMenuItem>
                ))}
              </DSelect>
            </section>
            <section className="line-115 line-116">
              <DSelect size="small" value={nature}
                onChange={changeNature} displayEmpty={true}
                renderValue={() => {
                  return !nature ? <span className="placeholder-111">企业性质</span> : nature;
                }}>
                {natureList.map((item: any) => (
                  <DMenuItem key={item.code} value={item.name}>{item.name}</DMenuItem>
                ))}
              </DSelect>
            </section>
          </section>
          <LoginButton onClick={onSubmit}
            style={{ backgroundColor: mainColor }}>确定
          </LoginButton>
        </section>
      </LoginComp>
      <SingleModal />
    </section>
  );
};

export default observer(RegisterSetting);
